export default __webpack_public_path__ + "static/media/fastingvacation@3x.d97c0668.jpg";